import { render, staticRenderFns } from "./WorksGalleryView.vue?vue&type=template&id=11b8c90b&scoped=true"
import script from "./WorksGalleryView.vue?vue&type=script&lang=js"
export * from "./WorksGalleryView.vue?vue&type=script&lang=js"
import style0 from "./WorksGalleryView.vue?vue&type=style&index=0&id=11b8c90b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11b8c90b",
  null
  
)

export default component.exports